<template>
  <div>
    <div class="row">
      <div class="col">
        
        <label>Archivo:
          <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUpload()" capture/>
        </label>
        <button v-on:click="submitFile()">Enviar</button>
        <button v-on:click.prevent="getFiles">Actualizar</button>

        <p v-for="item in filesUploaded" :key="item.id">
          <a :href="item.url" target="_blank" @click.prevent="setImage(item)"> {{item.original_name}}</a>
        </p>
        
      </div>
    </div>
    <div class="row">
      <div class="col">
       
        <!-- <img v-if="imageUrl" :src="imageUrl" class="img-fluid" alt=""> -->
        <img v-if="blobImage" :src="blobImage" class="responsive" alt="">
      
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {authHeader} from './../_helpers/_auth-header';
import pedidoArchivosService from  './../_services/pedidoarchivos.service';
import axios from 'axios';

export default {
  props: ['empresa_id', 'pedido_id'],
  data() {
    return {
      file: '',
      imageUrl: '',
      filesUploaded: [],
      blobImage: null,
      blobDownload: null
    }
  },
  computed: {
    ...mapState(['urlBase']),
    urlApiPedidoArchivos() {
      return this.urlBase + `/api/v3/${this.empresa_id}/pedidos/archivos/${this.pedido_id}`;
    }
  },
  
  mounted() {
    console.log('UploadPedidoArchivo mounted!');
    // this.getFiles();
  },

  methods: {

    setImage (item) {
      pedidoArchivosService.getArchivo(item.pedido_id, item.id)
        .then((blobResult) => {
          if(blobResult) {
            if(blobResult.type.includes('image')) {
              // visualiza imangen
              const url = window.URL.createObjectURL(new Blob([blobResult]));
              this.blobImage = url;
            } else {
              // Descarga archivo
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blobResult)
              link.download = item.original_name
              link.click()
            }
          }
        })
        .catch((error) => {
            console.log('catch getArchivo:', error);
        });
    },
    
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },

    submitFile() {
      let formData = new FormData;
      formData.append('archivo', this.file);

      pedidoArchivosService.sendArchivo(this.empresa_id, this.pedido_id, formData)
        .then(result => {
          console.log('Result del service: ', result);
        })
    },

    getFiles() {
      pedidoArchivosService.listArchivos(this.empresa_id, this.pedido_id)
        .then((files) => {
          if (files) {
            this.filesUploaded = [];
            for (let i = 0; i < files.length; i++) {
              this.filesUploaded.push(files[i]);
            }
          }
        })
        .catch((error) => {
            console.log('catch getFiles:', error);
        });
    }

  }
}
</script>
